import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';
import { getPageTitle } from 'src/config/projectConfig';

type UnderDevelopmentProps = {
  title?: string;
};

const TITLE_BY_PATH: Record<string, string> = {
  '/dashboard/ssl-overview': 'SSL Overview',
  '/dashboard/backup-overview': 'Backup Overview',
  '/dashboard/dynamic': 'Dynamic Dashboard',
  '/backup/overview': 'Backup Overview',
  '/security/ssl': 'SSL',
  '/administration/roles-permissions': 'Roles & Permissions',
  '/administration/audit-log': 'Audit Log',
};

const UnderDevelopment: FC<UnderDevelopmentProps> = ({ title }) => {
  const { pathname } = useLocation();
  const heading = title ?? TITLE_BY_PATH[pathname] ?? 'This section';

  return (
    <>
      <Helmet>
        <title>{getPageTitle(heading)}</title>
      </Helmet>
      <Box p={3}>
        <Typography variant="h4" style={{ fontWeight: 600 }} gutterBottom>
          {heading}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Under Development
        </Typography>
      </Box>
    </>
  );
};

export default UnderDevelopment;
